import React, { useEffect } from 'react';
import type { Page as PageType } from 'src/api/types/page';
import { TandC2,TandC3,TandC4,TandC5,TandC6,TandC7,TandC8,TandC9,TandC10,TandC11} from './termsAndCondition';
import {
    Box,
    Button,
    Container,
    Typography,
 
} from '@mui/material';
import { motion } from 'framer-motion';

const TermAndCondition: PageType = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when this component is mounted
  }, []);

    return (
        <Box>
        <Box
            component="section"
            sx={{
                backgroundColor: '#0F1521',
                color: 'common.white',
                position: 'relative',
                overflow: 'hidden',
                py: { xs: 6, md: 10 },
                minHeight: { xs: 'auto', md: '80vh' },
                display: 'flex',
                alignItems: 'center'
            }}
        >
            {/* Animated gradient background */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: 0.1,
                    background: 'radial-gradient(circle at 50% 50%, #FF6B00 0%, transparent 50%)',
                    animation: 'pulse 8s ease-in-out infinite',
                    '@keyframes pulse': {
                        '0%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.5)' },
                        '100%': { transform: 'scale(1)' }
                    }
                }}
            />
            <motion.div
                initial={{ width: 0 }}
                animate={{ width: '100px' }}
                transition={{ duration: 1, delay: 0.5 }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '20%',
                        left: '20%',
                        height: '2px',
                        backgroundColor: '#FF6B00',
                        opacity: 0.3,
                        zIndex: 0
                    }}
                />
            </motion.div>

            {/* Globe image with parallax effect */}
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 0.8, scale: 1 }}
                transition={{ duration: 1.5 }}
                style={{
                    position: 'absolute',
                    bottom: '-15%',
                    right: '0%',
                    width: '70%',
                    maxWidth: '1000px',
                    zIndex: 0,
                }}
            >
                <Box
                    component="img"
                    src="/globe.avif"
                    alt="Globe"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        filter: 'hue-rotate(30deg) saturate(0.8)',
                        animation: 'float 6s ease-in-out infinite',
                        '@keyframes float': {
                            '0%, 100%': { transform: 'translateY(0px)' },
                            '50%': { transform: 'translateY(-20px)' }
                        }
                    }}
                />
            </motion.div>

            <Container
                maxWidth="lg"
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    mt: { xs: 0, md: -10 }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        maxWidth: '700px',
                        mx: 'auto',
                        textAlign: 'center'
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <Typography
                            variant="h2"
                            sx={{
                                color: 'common.white',
                                fontWeight: 700,
                                mb: { xs: 3, md: 4 },
                                fontSize: { xs: '2.5rem', sm: '3rem', md: '4.25rem' },
                                lineHeight: 2.3,
                                textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}
                        >
                          Terms &{' '}
                            <Typography
                                component="span"
                                variant="inherit"
                                sx={{
                                    background: 'linear-gradient(90deg, #FF6B00 0%, #FF9D00 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontWeight: 700
                                }}
                            >
                                Condition
                            </Typography>
                        </Typography>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                    >
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.6 }}
                        whileHover={{ scale: 1.05 }}
                    >
                        <Button
                            component="a"
                            href="https://cal.com/support-team-qsszsx"
                            target="_blank"
                            variant="contained"
                            size="large"
                            sx={{
                                py: 1.25,
                                px: 4,
                                borderRadius: 2,
                                fontSize: '0.9rem',
                                fontWeight: 600,
                                background: 'linear-gradient(90deg, #FF6B00 0%, #FF9D00 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #FF9D00 0%, #FF6B00 100%)',
                                },
                                boxShadow: '0 4px 14px 0 rgba(255, 107, 0, 0.4)',
                                position: 'relative',
                                overflow: 'hidden',
                                '&::after': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: '-100%',
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                    animation: 'shimmer 2s infinite',
                                },
                                '@keyframes shimmer': {
                                    '100%': {
                                        left: '100%',
                                    },
                                }
                            }}
                        >
                            Talk to us
                        </Button>
                    </motion.div>
                </Box>
            </Container>


        </Box>
        <Box 
         sx={{
            backgroundColor: 'white',
            color: 'black',
            display: 'flex',
            flexDirection: 'column',
            px: {
              xs: 2.5,  // 20px (1 spacing unit = 8px)
              md: 3.75, // 30px
              lg: 8.25  // 50px
            },
            py: {
                xs: 2.5,  // 20px (1 spacing unit = 8px)
                md: 3.75, // 30px
                lg: 4.25  // 50px
              }
            
         
        }}>
          <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                
                    mt: 2,
                }}
            >
            Dear User,
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    
                }}
            >
           Welcome to Swift Ramp!
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
          
    Please read these TERMS AND CONDITIONS carefully. By clicking the "create account" button or by accessing or using the services, you agree to be legally bound by these terms and conditions and all terms incorporated by reference. You agree that you have read, understood and accepted all of the Terms And Conditions stated below as well as Privacy Policy.
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
          We reserve the right to change, add, remove or modify the Platform, the Service, these Terms, Privacy Policy or any content or part thereof, at any time, with or without notice, in our sole discretion. We may (but we don’t assume any such obligation) provide you a notification of any such change, add, remove or modify. You shall regularly and periodically check these Terms, Privacy Policy, before you make any transaction on the Platform. We shall have no liability or responsibility whatsoever due to any such changes, additions, removals or modifications.
        </Typography>
        <Typography
  sx={{
    textDecoration: 'underline',
    textDecorationColor: 'black', 
    fontFamily: 'Satoshi, sans-serif',
    color: '#FF6B00',
    fontWeight: 700,
    mt:2,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.5,
  }}
>
  “Specified Disclaimer: Crypto products are unregulated and can be highly risky. There may be no regulatory recourse for any loss from such transactions.”
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:3
                    
                }}
            >
           In the event that applicable laws were to change (including by way of a judicial or executive order) and render dealing, trading, holding and/or storing Cryptos to be invalid or illegal in India, these Terms shall stand automatically terminated with effect from the date of such invalidity/illegality without further notice or recourse available to User. You represent and declare that you have full knowledge and disclosure of the current Government and regulatory status with respect to Crypto Assets in India and the risk involved in dealing with, or trading in, or storing the same. By accessing the Platform and/or the Services, YOU are deemed to have understood, agreed to and accepted the risks, losses, and costs with respect to the same including but not limited to total / complete loss / seizure of Your Crypto Assets accounted for in PlatinX Exchange Crypto Custody Wallet and/or Your fiat balances.
          Certain definitions: As used herein:

       
        </Typography>
        <Typography
        sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt:2,
            textAlign: 'justify',
        }}
>
  <span
    style={{
        color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black', // Black underline
      fontWeight: 700,
    }}
  >
    “LLP”, “PlatinX Exchange”, “Ourselves”, “Us”, “Our” and “We”
  </span>{' '}
  refers to PlatinX Exchange which expression shall include its successors and assigns.
       </Typography>
       <Typography
        sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt:2,
            textAlign: 'justify',
        }}
>
  <span
    style={{
        color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black', // Black underline
      fontWeight: 700,
    }}
  >
    “User”, “You” and “Your”
  </span>{' '}
  refers to any person who uses the Platform or Services which expression shall include successors, heirs, receivers, and permitted assigns.
       </Typography>
         <Typography
        sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt:2,
            textAlign: 'justify',
        }}
>
  <span
    style={{
        color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black', // Black underline
      fontWeight: 700,
    }}
  >
   “Party”
  </span>{' '}
  refers to either You or Us and
  <span
    style={{
        color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black', // Black underline
      fontWeight: 700,
    }}
  >
 “Parties” 
  </span>{' '}
   
   refers to You and Us collectively, as the context may require.
       </Typography>
        <Typography
        sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt:2,
            textAlign: 'justify',
        }}
>
  <span
    style={{
        color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black', // Black underline
      fontWeight: 700,
    }}
  >
    “Crypto, Cryptos or Crypto Assets”
  </span>{' '}
  refers to a cryptographically secured digital representation of value or contractual rights that uses distributed ledger technology and can be transferred, stored or traded electronically using the Platform, including but not limited to Bitcoin and Ether
        </Typography>
        <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 700,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 4,
    textAlign: 'justify',
  }}
>
  <span style={{ fontWeight: 700, textDecoration: 'underline' }}>1.</span> About the Platform, Services, and certain related terms:
       </Typography>
       <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.1
  </span>{' '}
  The Platform is an online Crypto trading platform that currently provides following services to the Users
      </Typography>
      <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.1.1
  </span>{' '}
  online trading of Crypto by way of placing sale and/or purchase orders of Users on third party Crypto exchanges; and,
     </Typography>
     <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.1.2
  </span>{' '}
  online storage of Crypto transacted by the Users through third party Crypto exchanges as provided above
  <span style={{ fontStyle: 'italic' }}> (collectively the “Services“).</span>
    </Typography>
    <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.2
  </span>{' '}
  For the avoidance of doubt:
    </Typography>
    <Typography
        sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt:2,
            textAlign: 'justify',
        }}
>
The Platform provides access to its Services to the Users as under:
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.2.1
  </span>{' '}
  by aggregating the last traded price of Crypto on various third-party crypto exchanges and thereby, executing transactions for buying / selling Cryptos for and on the specific instructions (which are essentially electronic in nature) of its Users through such third-party Crypto exchanges. In other words, the Platform is an aggregator of various third-party Crypto exchanges and functions on the instructions (which are essentially electronic in nature) of its Users and provides Assured Quantity Service. The actual buy / sell of Cryptos is done on the platform of the third party Crypto exchange on specific instructions (which are essentially electronic in nature) from the User and the Platform executes the buy / sell orders instructions of its Users on such third party Crypto exchanges, and
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.2.2
  </span>{' '}
  by acting as a duly appointed payment collection agent, as provided under Our Trading Policy, of the Users for the limited purpose of facilitating payment for Cryptos transacted on third party Crypto exchanges and to hold Users’ money in trust in furtherance thereof, and
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.2.3
  </span>{' '}
  by electronically storing / keeping in custody in trust, Cryptos purchased by the Users. Such storage / custody is currently provided through third party Crypto custody providers and/or third-party Crypto exchanges as referred above
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.3
  </span>{' '}
  PlatinX Exchange is neither the creator nor the administrator of any Crypto. PlatinX Exchange acts as an intermediary between the User and various third party Crypto exchanges. PlatinX Exchange may, acting on the specific instructions of the User, execute orders on third-party Crypto exchange platforms. You hereby authorize PlatinX Exchange to act on your instructions (which are essentially electronic in nature) to undertake various trades and hold the Crypto in trust on behalf of the User.
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.4
  </span>{' '}
  PlatinX Exchange only acts as a service provider, information intermediary, facilitator of User transactions on third party Crypto exchanges, and a technology provider. In case of any technical or manual error including but not limited to downtime and /or unavailability of the Platform, PlatinX Exchange will take reasonable steps of correction to restore the Platform. If such correction creates a liability on You or You suffer any losses or damages, You will be required to incur that liability, loss or damages. PlatinX Exchange hereby disclaims liability for any such error or correction thereof, and no recourse may be had by User against PlatinX Exchange for any such error or correction.
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.5
  </span>{' '}
  Save and except as required under any applicable law or force majeure or related events (as more specifically described in these Terms), as long as you agree to and comply with these Terms of Use, PlatinX Exchange grants to You a limited personal, non-exclusive, non-transferable, non-sub-licensable, revocable and limited right to access and use the Platform and the Service in India as per these Terms. PlatinX Exchange may deploy technologies or processes to enforce the above grant of rights.
    </Typography>
    <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.6
  </span>{' '}
  Unless otherwise specified, all prices of Cryptos, content, logo, material, design, graphic symbols etc (“Materials”) on the Platform are the property of PlatinX Exchange or its licensors / third parties and are protected by patents, copyright, trademark, and other applicable laws. You may view such Materials on any single computer or electronic device solely for Your own internal use, provided You keep intact all copyright and other proprietary notices. The trademarks, service marks, and logos of PlatinX Exchange or its licensors / third parties and others used in this Platform (“Trademarks”) are the property of PlatinX Exchange and their respective licensors / third parties. The software, text, images, graphics, data, prices, trades, charts, graphs, video, and audio used on this Platform belong to PlatinX Exchange. The Trademarks and Materials should not be copied, reproduced, modified, republished, uploaded, posted, transmitted, scraped, collected or distributed in any form or by any means, whether manual or automated. The use of any such Materials on any other website, mobile application or networked computer environment for any other purpose or other commercial / non-commercial reasons is strictly prohibited, and any such unauthorized use may violate copyright, trademark, and other applicable laws and could result in criminal or civil legal actions and penalties.
   </Typography>
   <Typography
  sx={{
    fontFamily: 'Satoshi, sans-serif',
    fontWeight: 400,
    fontSize: {
      xs: '16px',
      sm: '18px',
      md: '20px',
    },
    lineHeight: 1.7,
    color: 'black',
    mt: 2,
    textAlign: 'justify',
  }}
>
  <span
    style={{
      color: '#FF6B00',
      textDecoration: 'underline',
      textDecorationColor: 'black',
      fontWeight: 700,
    }}
  >
    1.7
  </span>{' '}
  The Platform may provide links or other forms of reference to other websites (“External Platforms”) or resources over which We have no control. You acknowledge that PlatinX Exchange is providing any such links or references of external platforms or resources to You, including APIs to various third party Crypto exchanges, only as a convenience to You and that PlatinX Exchange makes no representations whatsoever about any external platforms which You may access through or via this Platform, including such external platforms being free of such items as viruses, worms, trojan horses, and other items of a destructive nature. PlatinX Exchange is not responsible for the availability of, and content provided on any External Platforms. You are requested to review the terms of use and policies posted by such External Platforms regarding privacy and other topics before use. PlatinX Exchange is not responsible for third party content accessible through the Platform, including opinions, advice, statements, prices, activities, and advertisements, and You shall bear all risks associated with the use of such content or trading Cryptos on such External Platforms.
   </Typography>
    <Typography  sx={{
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
        2. User Registration
   </Typography>
   {TandC2.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
       <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
        3. Electronic communications
     </Typography>
     {TandC3.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
      <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
       4. Activities Prohibited on the Platform
     </Typography>
     {TandC4.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
         <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
      5. Fee:
     </Typography>
     {TandC5.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
         <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
      6. Taxes:
     </Typography>
     {TandC6.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
         <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
      7. Risks and Disclaimers:
     </Typography>
     {TandC7.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            textTransform: 'lowercase',
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
                textTransform: 'lowercase',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
       <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
    8. Limitation of Liability:
     </Typography>
     {TandC8.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            textTransform: 'lowercase',
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
                textTransform: 'lowercase',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
          <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
   9. Financial Regulation and Advice:
          </Typography>
          {TandC9.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            textTransform: 'lowercase',
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
                textTransform: 'lowercase',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
      <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
      10. Assignment; Entire Agreement; Waiver:
          </Typography>
          {TandC10.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            textTransform: 'lowercase',
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
                textTransform: 'lowercase',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
      <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
      11. Termination and Suspension:
          </Typography>
          {TandC11.map((section, index) => (
        <Typography
          key={index}
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 400,
            textTransform: 'lowercase',
            fontSize: {
              xs: '16px',
              sm: '18px',
              md: '20px',
            },
            lineHeight: 1.7,
            color: 'black',
            mt: 2,
            textAlign: 'justify',
          }}
        >
          <span
            style={{
              color: '#FF6B00',
              textDecoration: 'underline',
              textDecorationColor: 'black',
                textTransform: 'lowercase',
              fontWeight: 700,
            }}
          >
            {section.title}
          </span>{' '}
          {section.content}
        </Typography>
      ))}
        <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
     12. Indemnity:
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                
                    mt: 2,
                }}
            >
           To the full extent permitted by applicable law, you hereby indemnify, defend and hold- harmless PlatinX Exchange, and its affiliates, officers, directors, partners, agents, employees, and suppliers against any Losses, action, liability, cost, claim, loss, damage, proceeding or expense suffered or incurred from your use of the Platform and/or Service / Your PlatinX Exchange Account / transfers from or transfers into the PlatinX Exchange Crypto Custody Wallet or any other Crypto wallet belonging to you and/or from your violation of these Terms, Privacy Policy, and AML Policy including but not limited to your violation of applicable laws while using the Platform and/or Services.
        </Typography>
        <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
   13. Contact:
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
                If You have any questions relating to these Terms of Use, Your rights and obligations arising from these Terms of Use and/or Your use of the Platform and the Service, or any other matter, please contact our Grievance Officer:
      </Typography>
      <Typography  sx={{ 
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
   14. Governing Law and Jurisdiction:
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
                These Terms of Use shall be governed and construed in accordance with the laws of India without giving effect to its principles of conflict of laws. The Parties agree to irrevocably submit to the exclusive jurisdiction of the courts situated in New Delhi, India for the resolution of any disputes or differences arising from these Terms of Use.
      </Typography>
      <Typography  sx={{  
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
15. Further Assurances:
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
                The User shall execute and deliver such additional instruments and other documents and shall take such further actions as may be necessary or appropriate to effectuate, carry out and comply with all of the terms of these Terms and applicable law.
      </Typography>
      <Typography  sx={{  
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
16. Severability:
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
        If any word, phrase, sentence, clause or provision of these Terms as applied to a party or to any circumstance is adjudged by a court to be invalid or unenforceable, the same will in no way affect any other circumstance or the validity or enforceability of any other word, phrase, sentence, clause or provision of these Terms. If any provision of these Terms, or any part thereof, is held to be unenforceable because of the duration of such provision or the area covered thereby, the parties agree that the court making such determination shall have the power to reduce the duration and/or area of such provision, and/or to delete specific words or phrases, and in its reduced form, such provision shall then be enforceable and shall be enforced.
      </Typography>
      <Typography  sx={{  
         color: '#FF6B00',
         textDecoration: 'underline',
         textDecorationColor: 'black',
         fontWeight: 700,
         fontFamily: 'Satoshi, sans-serif',
         mt:2,
         fontSize: {
            xs: '16px',
            sm: '18px',
            md: '20px',
          },
        
    }}
    >
17. Cumulative Remedies:
        </Typography>
        <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '16px',  // small screens
                    sm: '18px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.5,
                    mt:1
                    
                }}
            >
                The rights and remedies of PlatinX Exchange provided by these Terms are cumulative and the use of any one right or remedy shall not preclude or waive its right to use any or all other remedies. Said rights and remedies are given in addition to any other rights PlatinX Exchange may have under applicable law.
      </Typography>
        </Box>
        </Box>
    );
}; 
export default TermAndCondition;